<template>
    <div class="tw-flex tw-items-end">
        <div v-show="chatFeature == 'on' || chat">
            <div v-show="!openChat">
            
                <div class="tw-relative tw-py-2 tw-pointer-events-auto" style="" data-toggle="tooltip" data-placement="top" title="Questions? Ask PIA here">
                    <div>    
                        <span v-if="hasNewMessage" class="badge tw-absolute label-danger" style="top: -5px; right: -5px;">!</span>
                    </div>
                    
                    <div v-if="!isPIA" class="btn btn-info tw-rounded-full tw-flex tw-items-center tw-justify-center" style="height: 40px; width: 40px;" @click="toggleChat" >
                        <i class="gi gi-chat"></i>
                    </div>
                    <div v-else class="btn btn-info" @click="toggleChat" >
                    {{chat ? chat.initializedByName : 'chat'}}
                    </div>
                </div>
            </div>
            <div v-show="openChat" class="block tw-z-50">
                <div class="block-title ">
                    <div class="tw-flex tw-justify-between">
                        
                        <h3>Chat with PIA</h3>
                        
                        <!--  class=" tw-pt-0 tw-px-1" tw-pt-0 -->
                        <div class="tw-flex tw-space-x-1 tw-mr-2">
                            <div class="tw-mr-3 tw-flex tw-space-x-1">
                                <div v-if="userNum < 9">    
                                    <modal-button type="button" class="tw-my-2 tw-px-2 tw-p-0 btn btn-secondary" style="height: 25px" v-if="isPIA" :target="'addUserToChat' + uuid">+ User</modal-button>
                                </div>
                                <!-- <button class="tw-m-2 btn btn-secondary" type="button" @click="toggleChat" style="height: 30px;">-</button> -->
                                
                                <button v-if="!isPIA" class="tw-my-2 tw-px-2 tw-p-0 btn btn-secondary" type="button" @click="endChat" style="height: 25px">End</button>
                            </div>
                            <button class="tw-m-2 tw-p-0 btn btn-secondary" type="button" @click="toggleChat" style="height: 25px; width: 25px"><i class="fa fa-minus"></i></button>
                            <button v-if="isPIA" class="tw-m-2 tw-p-0 btn btn-secondary" type="button" @click="removeFromScreen" style="height: 25px; width: 25px">x</button>
                            
                        </div>
                    </div>
                    <div v-if="isPIA">
                        <base-form :ajax="true" :action="'/chat/' + this.chatId + '/changeSubject'" >
                            <div class="input-group">
                                <form-control name="subject">
                                    <input type="text" name="subject" v-model="chatSubject">
                                </form-control>
                                <span class="input-group-btn">
                                    <button type="submit" class="btn btn-success" style=""><i class="fa fa-check"></i></button>
                                </span>
                            </div>
                        </base-form>
                    </div>
                </div>
                <div :id="'scrollToBottom' + uuid" class="tw-overflow-auto scrollToBottom" style="width: 300px; height: 400px;">
                    <div style="text-align: center" class="tw-m-4 tw-p-3">
                        Chats may be recorded by the system. Never send any private or sensitive data (credit card information, SSN, etc.) through the chat.
                    </div>
                    <div v-for="msg of messages" class="tw-m-3">
                        
                        <div v-if="msg.status == 'systemMsg'" style="text-align: center" class="tw-m-4 tw-p-3">
                            <div class="badge tw-font-semibold tw-mr-2" :style="'height: 15px; background-color: ' + msg.color + '; color: ' + msg.color">.</div>
                            {{msg.text}}
                        </div>
                        <div v-else>
                            <div>{{msg.writtenByName}}</div>
                            <div :style="'word-break: break-word; background-color: ' + msg.color" :class="'tw-p-2 tw-rounded-t-xl ' + (msg.writtenById == userId ? 'tw-rounded-l-xl' : 'tw-rounded-r-xl')">{{msg.text}}</div>
                        
                        </div>
                    </div>
                </div>
                <div class="block-footer">
                    <div class="input-group">
                        <textarea class="form-control" style="height: 40px" type="text" name="msgText" v-model="msgText" @keyup.enter="sendMsg"></textarea>
                        
                        <span class="input-group-btn">
                            <button type="button" class="btn btn-success" @click="sendMsg" style="height: 40px; width: 40px"><i class="fa fa-send"></i></button>
                        </span>
                    </div>
                </div>
            </div>
            <modal-content :name="'addUserToChat' + uuid">
                <template #body>
                    <data-table :source="'/api/users?accessLevel=onlyPIA&chat=' + chat.id" placeholder="Search Names">
                        
                        <template #header="{addParameter}" v-slot="{addParameter}">
                            <div class="tw-flex tw-items-center tw-justify-end tw-border-r tw-pr-2 tw-mr-2">
                                
                                <!-- <div class="tw-flex tw-space-x-2">
                                    
                                    <select name="accessLevel" class="form-control sm:tw-w-64" @input="addParameter('accessLevel', $event.target.value)">
                                        <option value="onlyPIA" selected>Only PIA</option>
                                        <option value="onlyNonPIA">Only Non-PIA</option>
                                        <option value="onlyCompanyAdmins">Only Agency/Company Admins</option>
                                    </select>
                                </div> -->
                            </div>
                        </template>
                        <template #columns>
                            <tr>
                                <th is="data-table-column" column="participants.firstName" direction="asc" :initial="true">First Name</th>
                                <th is="data-table-column" column="participants.lastName" direction="asc">Last Name</th>
                                
                                <th is="data-table-column" column="companies.name" direction="asc">Agency/Company Admin</th>
                                <th class="tw-p-4 tw-hidden md:tw-table-cell" >PIA Admin</th>
                                <th></th>
                            </tr>
                        </template>
                        <template #rows="{ rows }">
                        
                            <tr v-for="(user, index) of rows" :index="index" v-if="user.id != userId">
                                <td class="tw-p-4">{{user.firstName}}</td>
                                <td class="tw-p-4">{{user.lastName}} <div v-if="user.deactivated"> deactivated</div></td>
                                <td class="tw-p-4">{{user.company && user.isAdminOfCompany ? user.company.name : ""}}</td>
                                <td class="tw-p-4">
                                    <p v-if="user.isPIA"><i class="fa fa-check tw-text-xl text-success"></i></p>
                                    <p v-else>-</p>
                                </td>
                                <td class="tw-p-4 tw-text-right">
                                    <button class="btn btn-default" @click="addParty(user.id)">+</button>
                                </td>
                            </tr>
                            
                        </template>
                    </data-table>
                </template>
            </modal-content>
        </div>
    </div>
</template>

<script>
import Echo from 'laravel-echo';
import { v4 as uuidv4 } from 'uuid';
export default {
    name: "Chat",

    props:{
        userId: { 
        },
        isPIA: {
            default: false,
        },
        startingChatId:{

        },
        chatIsAvailable:{

        },
        startOpen:{
            default: false,
        }
    },
 
    data() {
        return {
            openChat: this.startOpen,
            messages: [],
            chatId: this.startingChatId,
            chat: null,
            userNum: 0,
            msgText: null,
            uuid: uuidv4(),
            hasNewMessage: false,
            chatFeature: this.chatId || this.chatIsAvailable ? 'on' : 'off',
            chatSubject: null,
        }
    },

    mounted(){
        // this.$nextTick(() => {
        //     setTimeout(this.checkForMessages, 4000);
        // });

        // Initialize Echo - stuff copied from AccepteHosted
        window.Pusher = require('pusher-js');

        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: 'pusher-key',
            wsHost: window.location.hostname,
            wsPort: 6001,
            wssPort: 6001,
            cluster: 'mt1',
            forceTLS: this.appEnvironment == 'production',
            disableStats: true
        });

        window.Echo.connector.pusher.connection.bind('connected', () => {
            console.log('connected to websocket server');
            
        });

        window.Echo.connector.pusher.connection.bind('unavailable', () => {
            console.log('websocket server unavailable');
            
        });

        // From the Pusher docs:
        // Channels is not supported by the browser. This implies that WebSockets are not natively available and an HTTP-based transport could not be found.
        window.Echo.connector.pusher.connection.bind('failed', () => {
            console.log('pusher failed');
            
        });

        // Connection error
        window.Echo.connector.pusher.connection.bind('error', (error) => {
            console.log('websocket connection error');
            
        });

        if(this.chatId){
            this.subscribeToWebsocket(this.chatId);
            this.getChat(this.chatId); 
            
            this.$nextTick(() => {
                if(this.startOpen){
                    this.toggleChat();
                }else{
                    this.checkForUnreadMsgs();
                }
            });
        }

        window.Echo.channel('chat-availability') 
            .listen('ChatAvailability', event => {
                this.chatFeature = event.status;
            })
            .error(error => {
                console.error(error.message);
                console.log('error: did not get ChatAvailability');
            });
    },

    methods: {
        toggleChat(){
            console.log('toggleChat: ' + this.startingChatId + " " + this.chatId);
            if(this.openChat){
                this.openChat = false;
                console.log('minimizing chat');
                return;
            }

            /* if there is a chatId sent into the component, or a chat has been made already (and minimized), use that */
            let chatId = null;
            if(this.chat){
                chatId = this.chat.id;
                console.log('we have a chat.id' + chatId);
                this.getChat(chatId); 
            
            }else if(this.chatId){
                chatId = this.chatId;
                console.log('we have a chatId: ' + chatId);
                this.getChat(chatId); 
            
            }else{
                console.log('making new chat');
                this.chatId = this.makeNewChat();
            }
            
            // this.$nextTick( () => {
            //     this.$nextTick( () => {
            //         this.subscribeToWebsocket(chatId);
            //         console.log('between websocket and getChatMsg');
            //         this.getChatMsgs(chatId); 
            //     });
            // });
            
            this.openChat = true;
            this.hasNewMessage = false;
        },

        removeFromScreen(){
            console.log('removeFromScreen: ' + this.chatId);
            this.openChat = false;
            EventBus.$emit('remove-chat', this.chatId);
        },

        subscribeToWebsocket(chatId){
            
            console.log('in subscribeToWebsocket');
            
            window.Echo.private('chat.' + chatId) 
                        .listen('ChatUpdated', event => {
                            if(!this.openChat){
                                this.hasNewMessage = true;
                            }else{
                                this.getChatMsgs(chatId);
                            }
                        })
                        .error(error => {
                            console.error(error.message);
                            console.log('error: did not get ChatUpdated');
                        });
        },

        changeSubject(event){
            axios.post('/chat/' + this.chatId + '/changeSubject', {'subject': this.chatSubject})
                .then(response => {
                    this.chat = response.data;
                });
        },

        getChat(chatId){
            console.log('getChat');
            
            axios.get('/api/chat/' + chatId)
                .then(response => {
                    this.chat = response.data;
                    this.chatSubject = this.chat.subject;
                    this.userNum = response.data.userNum;

                    this.subscribeToWebsocket(chatId);
                    console.log('between websocket and getChatMsg');
                    this.getChatMsgs(chatId); 
                });
        },

        makeNewChat(){
            axios.get('/chat/create')
                .then(response => {
                    console.log('chat:');
                    console.log(response.data.id);
                    this.chat = response.data;
                    this.userNum = response.data.userNum;
                    this.chatId = response.data.id;

                    this.subscribeToWebsocket(this.chatId);
                    console.log('between websocket and getChatMsg');
                    this.getChatMsgs(this.chatId); 
                });
        },

        getChatMsgs(chatId){
            console.log('getChatMsgs');
            axios.get('/api/chat/' + chatId + '/messages')
                    .then(response => {
                        this.messages = response.data;
                        console.log('messages:');
                        console.log(this.messages);
                        this.$nextTick( () => {
                            this.scrollDivDown();
                        });
                    });
        },

        checkForUnreadMsgs(){
            axios.get('/api/chatMessages/unreadCounts?onlyList=true')
                    .then( response => {
                        console.log("message num: ");
                        console.log(response.data.includes(this.chat.id));
                        if(response.data.includes(this.chat.id)){
                            this.hasNewMessage = true;
                        }
                    });
        },

        sendMsg(){
            //console.log('sending message' + this.msgText);
            axios.post('/chat/' + this.chat.id + '/newMessage', {'text': this.msgText})
                    .then(response => {
                        console.log('made message:');
                        this.messages.push(response.data);
                        this.msgText = null;
                        this.$nextTick( () => {
                            this.scrollDivDown();
                        });
                    });
        },

        scrollDivDown(){
            console.log('scrolling down' + this.uuid);
            
            /* doesn't work this way
               let div = document.getElementById('scrollToBottom'); */
            //    console.log('scrollDivDown');
            //    console.log(document.getElementById('scrollToBottom' + this.uuid));
            // document.getElementById('scrollToBottom' + this.uuid).scrollTop = document.getElementById('scrollToBottom' + this.uuid).scrollHeight ?? 1;
            document.getElementsByClassName('scrollToBottom').forEach(viewDiv => {
                //console.log(viewDiv);
                viewDiv.scrollTop = viewDiv.scrollHeight;
            });
            console.log(this.isPIA + ";" + this.openChat);
            console.log(this);
            
            /* on the backend, marks all the messages for this chat as read, then sends out AlertPIAChatUpdated event */
            if(this.chat && this.openChat){
                console.log('reading messages');
                axios.get('/chat/' + this.chat.id + '/readMessages')
                    .then(response => {
                        console.log('marked as PIAread' + this.chat.id);
                    });
            }
        },

        addParty(userId){
            // console.log('let\'s add someone to the chat' + userId);
            // console.log(this.chat);
            let uri = '/chat/' + this.chat.id + '/addUser/' + userId;
            //console.log(uri);
            axios.get(uri)
                    .then(response => {
                        console.log('addedUser:');
                        console.log(response.data);
                        this.userNum = this.userNum + 1;
                        this.getChatMsgs(this.chat.id);
                        EventBus.$emit('close-modal');
                    });
        },

        endChat(){
            axios.get('/chat/' + this.chat.id + '/end')
                    .then(response => {
                        console.log('end chat:');
                        console.log(response.data);

                        window.Echo.private('chat.' + this.chat.id) 
                                    .stopListening('ChatUpdated')
                                    .error(error => {
                                        console.error(error.message);
                                        console.log('error: did not stop listening: ' + this.chat.id);
                                    });
                        this.chat = null;
                        this.chatId = null;
                        this.messages = [];
                        this.removeFromScreen();
                    });
        }
    }
}
</script>

<style>

</style>